import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.359 6.692h-.002v.172a3.851 3.851 0 0 1-2.37-3.1c-.004-.037-.056-.037-.062 0-.182 1.354-1.11 2.595-2.37 3.102V0H0v14.1h3.555V7.41h.002v-.174a3.854 3.854 0 0 1 2.37 3.1c.005.038.056.04.062 0 .182-1.354 1.11-2.594 2.37-3.1v6.865h3.557V0H8.359v6.692Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }